import React from 'react';
import { connect } from 'react-redux';
import { hideNotification } from './ducks';
import CustomNotification from '../../components/customNotification';


class Notification extends React.Component {
  render = () => {
    
    if (!this.props.visible) {
      return null;
    }   
    
    return (
      <CustomNotification
        type={this.props.type}
        text={this.props.text}
        buttonText={this.props.buttonText}
        buttonElement={this.props.buttonElement}
        onClick={this.props.onClick}
        hideNotification={this.props.hideNotification}
        zIndex={400}
      />
    );
  };
}

const mapStateToProps = (state) => {
  return {
    ...state.notification,
    type: state.notification.type,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideNotification: () => dispatch(hideNotification()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notification);